import React from 'react';
import './Protection.css';
import Fade from 'react-reveal/Fade';

const protection = () => {
    return (
        <div className="protection">
            <div className="container-fluid bg-1">
                <div className="main">
                    <Fade delay={300}>
                        <span className="content"> Protect Your Applications from </span>
                        <span className="content1"> Top 10 OWASP Vulnerabilities </span>
                    </Fade>
                </div>
                <div className="points-1">
                    <Fade delay={500}>
                        <div className="point1">
                            Injection
                    </div>
                    </Fade>
                    <Fade delay={600}>
                        <div className="point2">
                            Broken Access Control
                        </div>
                    </Fade>
                    <Fade delay={700}>
                        <div className="point3">
                            Cross-Site Scripting (XSS)
                        </div>
                    </Fade>
                    <Fade delay={800}>
                        <div className="point4">
                            XML External Entities (XXE)
                        </div>
                    </Fade>
                    <Fade delay={900}>
                        <div className="point5">
                            Using Components with Known Vulnerabilities
                        </div>
                    </Fade>
                </div>

                <div className="points-2">
                    <Fade delay={500}>
                        <div className="point1">
                            Insecure Deserialization
                        </div>
                    </Fade>
                    <Fade delay={600}>
                        <div className="point2">
                            Security Misconfiguration
                        </div>
                    </Fade>
                    <Fade delay={700}>
                        <div className="point3">
                            Insufficient Logging & Monitoring
                        </div>
                    </Fade>
                    <Fade delay={800}>
                        <div className="point4">
                            Sensitive Data Exposure
                        </div>
                    </Fade>
                    <Fade delay={900}>
                        <div className="point5">
                            Broken Authentication and Session Management
                        </div>
                    </Fade>
                </div>
            </div>
        </div>
    )
}

export default protection;